"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _localStorageCache = _interopRequireDefault(require("../../utils/localStorageCache"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'introduction_bar';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-introduction_bar';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.any();

exports.config = config;
var STORAGE_KEY = 'close--widget-cta';
var STORAGE_DAYS = 30;
var DAY_MS = 24 * 60 * 60 * 1000;
var HIDDEN_CLASS = 'is-transition--height-hidden';

var IntroductionBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IntroductionBar, _Component);

  var _super = _createSuper(IntroductionBar);

  function IntroductionBar() {
    var _this;

    (0, _classCallCheck2.default)(this, IntroductionBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isClosed: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClose", function () {
      _this.setState({
        isClosed: true
      });

      _localStorageCache.default.setItem(STORAGE_KEY, Date.now() + STORAGE_DAYS * DAY_MS);
    });
    return _this;
  }

  (0, _createClass2.default)(IntroductionBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var expiry = _localStorageCache.default.getItem(STORAGE_KEY);

      if (!expiry || Date.now() > expiry) {
        this.setState({
          isClosed: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)("section", {
        className: (0, _classnames.default)('full-width', 'Template-brand-cta', 'is-transition--height', 'custom-intro-bar', (0, _defineProperty2.default)({}, HIDDEN_CLASS, this.state.isClosed))
      }, (0, _preact.h)("div", {
        className: "cta-widget qa-cta-widget"
      }, (0, _preact.h)("div", {
        className: "sitewidth"
      }, (0, _preact.h)("span", {
        className: (0, _classnames.default)('icon', 'icon--cross', 'icon--auto-width', 'close', 'js-close--element'),
        "aria-hidden": "true",
        onClick: this.onClose
      }), (0, _preact.h)("div", {
        className: "col"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('box', 'widget', 'widget--cta')
      }, (0, _preact.h)("div", {
        className: "box__content box__pad"
      }, (0, _preact.h)("ul", {
        className: "list list--float"
      }, (0, _preact.h)("li", {
        className: "list__item"
      }, (0, _preact.h)("span", {
        className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', 'icon--checkmark'),
        "aria-hidden": "true"
      }), (0, _preact.h)("div", {
        className: "list--label"
      }, (0, _preact.h)(_phrase.default, {
        p: "branded.cta.intro.first"
      }))), (0, _preact.h)("li", {
        className: "list__item"
      }, (0, _preact.h)("span", {
        className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', 'icon--checkmark'),
        "aria-hidden": "true"
      }), (0, _preact.h)("div", {
        className: "list--label"
      }, (0, _preact.h)(_phrase.default, {
        p: "branded.cta.intro.second"
      }))), (0, _preact.h)("li", {
        className: "list__item"
      }, (0, _preact.h)("span", {
        className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', 'icon--checkmark'),
        "aria-hidden": "true"
      }), (0, _preact.h)("div", {
        className: "list--label"
      }, (0, _preact.h)(_phrase.default, {
        p: "branded.cta.intro.third"
      })))), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new"),
        "data-track": JSON.stringify({
          trigger: 'widget',
          type: 'Topic Initiated'
        }),
        "data-ga-track": JSON.stringify({
          eventCategory: 'Homepage',
          eventAction: 'Create topic clicked',
          eventLabel: {
            Position: 'Introduction widget'
          }
        }),
        className: (0, _classnames.default)('btn--cta', 'btn--new-topic', 'qa-topic-new-button')
      }, (0, _preact.h)(_phrase.default, {
        p: "Ask your question"
      })))), ' '))));
    }
  }]);
  return IntroductionBar;
}(_preact.Component);

var _default = IntroductionBar;
exports.default = _default;